import { render, staticRenderFns } from "./MoveCard.vue?vue&type=template&id=b186d6b0&"
import script from "./MoveCard.vue?vue&type=script&lang=js&"
export * from "./MoveCard.vue?vue&type=script&lang=js&"
import style0 from "./MoveCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports